const animateImages = () => {
  const sections = document.querySelectorAll(".section-main-blog");

  sections.forEach((item) => {
    const targets = item.querySelectorAll(".observe-me");
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const classList = entry.target.classList;
        classList.add("is-inview");
        currentObserver.unobserve(entry.target);

        setTimeout(() => {
          classList.remove("is-inview");
          classList.remove("observe-me");
        }, 1000);
      });
    }, {
      root: null,
      rootMargin: "0px 0px 700px 0px",
      threshold: 0.01,
    });

    targets.forEach((target) => observer.observe(target));
  });
};

const getLoadInput = (selector) => document.querySelector(selector);

const buildPageUrl = (url, page) => {
  const nextUrl = new URL(url, window.location.origin);
  nextUrl.searchParams.set("page", page);
  return nextUrl.toString();
};

const setCurrentPage = (page) => {
  document.querySelectorAll("input[data-current-page]").forEach((input) => {
    input.value = page;
    input.dataset.currentPage = page;
  });
};

const removeLoadControls = () => {
  document.querySelectorAll(".js-load-more, .js-infinite-scroll").forEach((control) => {
    control.remove();
  });
};

const loadItems = async (control) => {
  if (!control || control.dataset.loading === "true") return;

  const totalPages = Number.parseInt(getLoadInput("input[data-total-pages]")?.value || "1", 10);
  const currentPage = Number.parseInt(getLoadInput("input[data-current-page]")?.value || "1", 10);
  const sourceUrl = getLoadInput("input[data-next-url]")?.value;

  if (!sourceUrl || currentPage >= totalPages) {
    removeLoadControls();
    return;
  }

  const nextPage = currentPage + 1;
  control.dataset.loading = "true";
  control.setAttribute("disabled", "");
  control.classList.add("loading");

  try {
    const response = await fetch(buildPageUrl(sourceUrl, nextPage), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

    const responseHTML = await response.text();
    const responseDocument = new DOMParser().parseFromString(responseHTML, "text/html");
    const incomingGrid = responseDocument.querySelector(".load-more-grid");
    const grid = document.querySelector(".load-more-grid");

    if (incomingGrid && grid) {
      grid.insertAdjacentHTML("beforeend", incomingGrid.innerHTML);
    }

    setCurrentPage(nextPage);
    if (typeof colorSwatches === "function") colorSwatches();

    if (nextPage >= totalPages) {
      removeLoadControls();
    } else {
      control.removeAttribute("disabled");
      control.classList.remove("loading");
      control.dataset.loading = "false";
      checkVisibility();
    }

    animateImages();
    if (typeof loadeMoreSlider_G === "function") loadeMoreSlider_G();
  } catch (error) {
    control.removeAttribute("disabled");
    control.classList.remove("loading");
    control.dataset.loading = "false";
  }
};

const checkVisibility = () => {
  document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        currentObserver.unobserve(entry.target);
        loadItems(spinner);
      });
    }, {
      root: null,
      rootMargin: "0px 0px 700px 0px",
      threshold: 0.01,
    });

    sectionObserver.observe(spinner);
  });
};

let scrollCheckQueued = false;

const checkScrollPosition = () => {
  if (scrollCheckQueued) return;
  scrollCheckQueued = true;

  window.requestAnimationFrame(() => {
    scrollCheckQueued = false;
    const spinner = document.querySelector(".js-infinite-scroll");
    if (!spinner) return;

    const distanceFromViewport = spinner.getBoundingClientRect().top - window.innerHeight;
    if (distanceFromViewport <= 700) loadItems(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.addEventListener("click", () => loadItems(button));
  });

  checkVisibility();
  window.addEventListener("scroll", checkScrollPosition, { passive: true });
  window.addEventListener("resize", checkScrollPosition, { passive: true });
  checkScrollPosition();
  animateImages();
}

loadMore();
